/**
 * @file AI 助理数据看板主页面入口
 * @author izzieyspu
 */

import React from 'react';
import { useParams } from 'react-router-dom';

import Home from './home';
import Chat from './chat';

const Entry = () => {
  const { sessionId } = useParams<{ sessionId?: string }>();
  const sessionIdRef = React.useRef(sessionId);

  if (sessionIdRef.current) {
    return <Chat />;
  }

  return <Home />;
};

export default Entry;
